import React from "react";
import { NavLink } from "react-router-dom";

import { SidebarItem } from "./Sidebar";
import styles from "./Sidebar.module.scss";

interface SidebarLinkWrapperProps {
  item: SidebarItem;
  index: number;
}

const SidebarLinkWrapper: React.FC<
  React.PropsWithChildren<SidebarLinkWrapperProps>
> = ({ item, index, children }) => {
  return item.href ? (
    <a
      href={item.href}
      className={styles.item}
      key={item.name}
      data-testid={`sidebar-item-${index}`}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  ) : (
    <NavLink
      to={item.route ?? "/"}
      className={styles.item}
      activeClassName={styles.isActive}
      key={item.name}
      data-testid={`sidebar-item-${index}`}
    >
      {children}
    </NavLink>
  );
};

export default SidebarLinkWrapper;
